/*

  NOTE: Quotes come from an external api called Flexile.

  Requests are made through our API helper, which provides additional features such as mock
  data responses and custom data transformations. Full details of these features are documented in
  "api/apiHelper.js".
*/

import API from './apiHelper'

const flexileApi = process.env.VUE_APP_FLEXILE_ROOT

export default {
  getQuotes(search) {
    return API.get(
      `${flexileApi}/quotes?fields=name user updated status external&populate=user${
        search ? '&search=' + search : ''
      }`
    )
  },

  getQuote(id, spinner) {
    return API.get(
      `${flexileApi}/quotes/${id}?populate=user account products`,
      { spinner }
    )
  },

  getProducts() {
    return API.get(
      `${flexileApi}/schemas?type=Product&status=Active&visibility=Wholesale&fields=name`
    )
  },

  createQuote(data) {
    return API.post(`${flexileApi}/quotes`, { data })
  },

  updateQuote(data, spinner) {
    return API.put(`${flexileApi}/quotes/${data._id}`, {
      data,
      spinner
    })
  },

  postProduct(data, spinner) {
    return API.post(`${flexileApi}/products`, { data, spinner })
  }
}
